// src/plugins/refreshTokenInterceptor.js - Token Refresh Interceptor
import axios from 'axios';
import store from '../store';
import router from '../router';
import baseURL from '../networking/api';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export function setupRefreshTokenInterceptor() {
  // RESPONSE INTERCEPTOR FOR TOKEN REFRESH
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // 401 hatası ve "jwt expired" mesajı kontrolü
      if (error.response?.status === 401 && !originalRequest._retry) {
        // Token'ın gerçekten expire olduğunu kontrol et
        const errorMessage = error.response?.data?.message || '';
        const isTokenExpired = errorMessage.includes('jwt expired') ||
                              errorMessage.includes('Token süresi doldu') ||
                              errorMessage.includes('Unauthorized');

        if (!isTokenExpired) {
          // Token expire olmamış, başka bir 401 hatası
          return Promise.reject(error);
        }

        // Token yenilenirken diğer istekler beklesin
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers['Authorization'] = 'Bearer ' + token;
              return axios(originalRequest);
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        const refreshToken = store.state.userData.refreshToken;

        if (!refreshToken) {
          // Refresh token yok, login'e yönlendir
          isRefreshing = false;
          store.commit('signOut');
          router.push('/');
          return Promise.reject(error);
        }

        try {
          // Refresh token ile yeni access token al
          const response = await axios.post(`${baseURL}/users/refresh/token`, {
            refreshToken: refreshToken
          });

          const newAccessToken = response.data.data.token;

          // Yeni token'ı store'a kaydet
          store.state.userData.token = newAccessToken;

          // Axios default header'ını güncelle
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;

          // Original request'in header'ını güncelle
          originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;

          // Bekleyen istekleri işle
          processQueue(null, newAccessToken);

          isRefreshing = false;

          // Original request'i tekrar dene
          return axios(originalRequest);
        } catch (err) {
          // Refresh token da geçersiz - login'e yönlendir
          processQueue(err, null);
          isRefreshing = false;

          // Token'ları temizle ve login'e yönlendir
          localStorage.removeItem('vuex'); // vuex-persistedstate kullanıyor
          store.commit('signOut');

          // Kullanıcıya bilgi ver
          if (window.$swal) {
            window.$swal.fire({
              icon: 'warning',
              title: 'Oturum Süresi Doldu',
              text: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
              confirmButtonText: 'Tamam'
            }).then(() => {
              router.push('/');
            });
          } else {
            router.push('/');
          }

          return Promise.reject(err);
        }
      }

      return Promise.reject(error);
    }
  );

  // REQUEST INTERCEPTOR - Her istekte token'ı ekle
  axios.interceptors.request.use(
    (config) => {
      const token = store.state.userData.token;
      if (token && !config.headers['Authorization']) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
